import React from 'react'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import type { ITabContentLabelComponent } from '@/components/ui/Tabs/interfaces'
import type { IWithFinancingProductsTabProps } from './types'
import './styles.scss'

export const WithFinancingProductsTab =
  ({ icon, text }: IWithFinancingProductsTabProps): ITabContentLabelComponent =>
  () => {
    return (
      <span className="financingProductsTab">
        <Icon className="financingProductsTab__icon" component={icon} />
        <span className="financingProductsTab__text">{text}</span>
      </span>
    )
  }
